export function resolveInternalRedirect(redirect) {
  if (typeof redirect !== "string") return null;
  if (!redirect.startsWith("/") || redirect.startsWith("//")) return null;
  if (redirect.startsWith("/auth")) return null;

  return redirect;
}
